export const quoteConstants = {
    GET_REQUEST: 'QUOTE_GET_REQUEST',
    GET_SUCCESS: 'QUOTE_GET_SUCCESS',
    GET_FAILURE: 'QUOTEGET_FAILURE',
    GET_FAILURE_DONE: 'QUOTE_GET_FAILURE_DONE'
};